
export default {
  // Profile-related translations
  "profile_reviews": "Reviews",
  "profile_no_reviews": "No reviews yet",
  "profile_share_experience": "Share your experience with the film community!",
  "verified_traveler": "Verified Traveler",
  "verified_creative": "Verified Creative",
  "verified_traveler_tooltip": "This user is a verified traveler",
  "verified_creative_tooltip": "Verified photographer or creative professional",
};
